module.exports = function() {
	return new Worker(__webpack_public_path__ + "ef6cc9ef284a4ea9322f.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./scripts/workers/yaml.worker.js
// module id = 387
// module chunks = 0